//
//
//
//
//
//

export default {
    name: "center",
    props: ['background_image']
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/player/page/center.vue
// module id = 54
// module chunks = 0